<template>
  <div class="container">
    <el-form :model="form" inline ref="refForm" :rules="rules">
      <el-form-item class="small_label" :label="$t('common.boxNo') + ':'" prop="boxNo">
        <el-input
          v-model.trim="form.boxNo"
          name="boxNo"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 200px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.orderNo') + ':'" prop="incoOrderNo">
        <el-input
          v-model="form.incoOrderNo"
          name="incoOrderNo"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 200px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.lotNo') + ':'" prop="lotNo">
        <el-input
          v-model="form.lotNo"
          name="lotNo"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 150px;"
          maxlength="32"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.storePosition') + ':'" prop="storePosition">
        <el-input
          v-model="form.storePosition"
          name="storePosition"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 200px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.status') + ':'" prop="status">
        <el-select
          v-model="form.status"
          clearable
          filterable
          style="width: 180px;"
          size="small"
          collapse-tags
          multiple>
          <el-option
            v-for="(item, key) in incomeStorageStatus"
            :key="key"
            :label="item.explain"
            :value="item.val">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.entryTime') + ':'" prop="importDate">
        <el-date-picker
          v-model="form.importDate"
          type="daterange"
          size="small"
          clearable
          style="width: 250px;"
          :picker-options="pickerOptions"
          :default-value="defaultTime">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="reset">{{$t('common.reset')}}</el-button>
        <el-button type="primary" size="small" @click="queryIncoStorage">
          {{$t('common.query')}}
        </el-button>
      </el-form-item>
    </el-form>
    <div class="separator"></div>
    <div class="target-container">
      <el-table
        ref="table"
        height="100%"
        border
        :data="displayData"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName">
        <el-table-column prop="boxNo" :label="$t('common.boxNo')" width="200" fixed/>
        <el-table-column :label="$t('common.orderNo')" width="200">
          <template slot-scope="scope">
            {{orderNoVal(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.subNo')" width="200">
          <template slot-scope="scope">
            {{subNoVal(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column width="250" prop="lotNo" :label="$t('common.lotNo')">
        </el-table-column>
        <el-table-column prop="count" width="100" :label="$t('common.count')"/>
        <el-table-column width="80" :label="$t('common.status')">
          <template slot-scope="scope">
            {{storeStatusVal(scope.row.status)}}
          </template>
        </el-table-column>
        <el-table-column width="100" prop="storePosition" :label="$t('common.storePosition')">
        </el-table-column>
        <el-table-column :label="$t('common.entryTime')" width="150">
          <template slot-scope="scope">
            {{formatDate(scope.row.createAt)}}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('common.operate')" width="240">
          <template slot-scope="scope">
            <el-button v-if="isBoxReceived(scope.row)" type="text" class="link" @click="incoStorageCancelEntry(scope.row)">
              撤销入库
            </el-button>
            <span v-if="isBoxReceived(scope.row)" class="vertical-separator"/>
            <el-button v-if="isBoxReceived(scope.row)" type="text" class="link" @click="incoStorageDelivery(scope.row)">
              出库
            </el-button>
            <el-button v-if="isBoxDelivery(scope.row)" type="text" class="link" @click="incoStorageCancelDelivery(scope.row)">
              撤销出库
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('common.detail')" width="120">
          <template slot-scope="scope">
            <router-link :to="toLink(scope.row)">
              <el-button type="text" class="link">
                {{$t('common.detail')}}
              </el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      :total="totalCount"
      :pageSize="perpage"
      :current-page.sync="page"
      @current-change="onChangePage"
    />
  </div>
</template>

<script>
import moment from 'moment';
import {
  incoStorageList,
  incoStorageCancelEntry,
  incoStorageDelivery,
  incoStorageCancelDelivery,
} from '@/api/incoStorage';
import { storeStatus, incomeStorageStatus } from '@/utils/defines';
import {
  Pagination,
} from '@/components';

const defaultForm = {
  incoOrderNo: undefined,
  boxNo: undefined,
  lotNo: undefined,
  storePosition: undefined,
  status: undefined,
  importDate: undefined,
};

export default {
  name: 'IncomeStorageList',
  components: {
    Pagination,
  },
  data() {
    const storeStatusObj = {};
    let storeStatueItem;
    for (const key in storeStatus) {
      if (Object.prototype.hasOwnProperty.call(storeStatus, key)) {
        storeStatueItem = storeStatus[key];
        storeStatusObj[storeStatueItem.val] = storeStatueItem.explain;
      }
    }
    return {
      form: Object.assign({}, defaultForm),
      searchParams: Object.assign({}, defaultForm),
      rules: {
      },
      page: 1,
      perpage: 20,
      totalCount: 0,
      listData: [],
      importDialogVisible: false,
      storeStatusObj,
      incomeStorageStatus,
    };
  },
  computed: {
    displayData() {
      return this.listData;
    },
    pageCount() {
      return Math.ceil(this.totalCount / this.perpage);
    },
    pickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() > moment().add(1, 'days').valueOf();
        }
      };
    },
    defaultTime() {
      return moment().subtract(1, 'months').valueOf();
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.incoStorageList();
    })
  },
  methods: {
    onChangePage() {
      this.incoStorageList();
    },
    async incoStorageList() {
      try {
        const {
          incoOrderNo,
          boxNo,
          lotNo,
          storePosition,
          status,
          importDate,
        } = this.searchParams;
        let startDate;
        let endDate;
        if (importDate && importDate.length === 2) {
          [startDate, endDate] = importDate;
        }
        const res = await incoStorageList({
          page: this.page,
          perpage: this.perpage,
          incoOrderNo: incoOrderNo || undefined,
          boxNo: boxNo|| undefined,
          lotNo: lotNo || undefined,
          storePosition: storePosition || undefined,
          status: status && status.length > 0 ? JSON.stringify(status) : undefined,
          sdate: startDate,
          edate: endDate,
        });
        const { data } = res;
        if (data.count !== undefined) {
          this.totalCount = data.count;
        }
        this.listData = data.records;
      } catch (e) {
        // do nothing.
      }
    },
    reset() {
      this.page = 1;
      this.form = Object.assign({}, defaultForm);
      this.searchParams = Object.assign({}, defaultForm);
      this.incoStorageList();
    },
    queryIncoStorage() {
      this.page = 1;
      this.searchParams = {...this.form};
      this.incoStorageList();
    },
    orderNoVal(row) {
      const {
        incoOrder,
      } = row;
      if (!incoOrder) {
        return '';
      }
      const {
        incoOrderNo,
      } = incoOrder;
      return incoOrderNo;
    },
    subNoVal(row) {
      const {
        incoOrdersDetail,
      } = row;
      if (!incoOrdersDetail) {
        return '';
      }
      return incoOrdersDetail.subNo;
    },
    productNameVal(row) {
      const {
        incoOrder,
      } = row;
      if (!incoOrder) {
        return '';
      }
      const {
        product,
      } = incoOrder;
      if (!product) {
        return '';
      }
      return `${product.productName} / ${product.chipName} / ${product.packageType}`;
    },
    lotNoVal(row) {
      const {
        incoStores,
      } = row;
      if (!incoStores || incoStores && incoStores.length === 0) {
        return;
      }
      return incoStores[0].lotNo;
    },
    storeStatusVal(val) {
      return this.storeStatusObj[`${val}`];
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      const isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
      if (isSameYear) {
        return updateDate.local().format('MM/DD HH:mm:ss');
      }
      return updateDate.local().format('YYYY/MM/DD HH:mm:ss');
    },
    toLink(row) {
      const {
        id,
      } = row;
      return `/income-storage/edit/${id}`;
    },
    isBoxReceived(row) {
      return row.status === incomeStorageStatus.received.val;
    },
    isBoxDelivery(row) {
      return row.status === incomeStorageStatus.delivery.val;
    },
    incoStorageCancelEntry(row) {
      this.$confirm(this.$t('incomeStorage.thisActionWillCancelEntryTheBox'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        const {
          boxNo
        } = row;
        try {
          await incoStorageCancelEntry({
            boxNo,
          });
          this.$message({
            type: 'success',
            message: this.$t('common.cancelEntrySuccess'),
          });
          this.incoStorageList();
        } catch (e) {
          // do nothing.
        }
      }).catch(() => {
        // do nothing.
      });
    },
    incoStorageDelivery(row) {
      this.$confirm(this.$t('incomeStorage.thisActionWillDeliveryTheBox'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        const {
          boxNo
        } = row;
        try {
          await incoStorageDelivery({
            boxNo,
          });
          this.$message({
            type: 'success',
            message: this.$t('common.deliverySuccess'),
          });
          this.incoStorageList();
        } catch (e) {
          // do nothing.
        }
      }).catch(() => {
        // do nothing.
      });
    },
    incoStorageCancelDelivery(row) {
      this.$confirm(this.$t('incomeStorage.thisActionWillCancelDeliveryTheBox'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        const {
          boxNo
        } = row;
        try {
          await incoStorageCancelDelivery({
            boxNo,
          });
          this.$message({
            type: 'success',
            message: this.$t('common.cancelDeliverySuccess'),
          });
          this.incoStorageList();
        } catch (e) {
          // do nothing.
        }
      }).catch(() => {
        // do nothing.
      });
    }
  },
};
</script>

<style lang="less" scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }
  .el-form {
    padding: 10px 20px 0;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }
  .control-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    margin: 10px 20px;
  }
  .target-container {
    flex: 1;
    display: -webkit-flex;
    display: flex;
    margin: 20px 20px 0;
    height: 100%;
    overflow: auto;
  }
  .bottom-container {
    text-align: center;
    position: relative;
    margin: 20px auto;
    width: 100%;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
  .vertical-separator {
    display: inline-block;
    width: 1px;
    height: 12px;
    margin: 0 13px;
    vertical-align: middle;
    background: #e8e8e8;
  }
  /deep/ .el-table--border th.gutter:last-of-type {
    border-bottom: 0;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }
  .small_label .el-form-item__label {
    font-size: 12px;
  }
</style>
